export default __webpack_public_path__ + "img/3-1-1f723b3c.png";